import 'reflect-metadata';

function PropMetaData<T extends Record<string, any> = Record<string, any>>(metaData: T): PropertyDecorator {
	return function (target: any, propertyKey: string) {
		Reflect.defineMetadata(METADATA_DECORATOR_KEY.valueOf(), metaData, target, propertyKey);
	};
}

/**
 * ClassMetaData decorator to add metadata to a class
 * @param metaData
 * @constructor
 * ```ts
 * @ClassMetaData({translation: 'pages.cw.eventactions.eventtypes.cyclefinished'})
 * export class CycleCompletingTrigger extends BaseCycleStatusTriggerEntity {
 * ...
 *	}
 * const classInstance = new CycleCompletingTrigger();
 * const metaData = Reflect.getMetadata('metadata', classInstance);
 * // or
 * const metaData = Reflect.getMetadata('metadata', CycleCompletingTrigger);
 */
function ClassMetaData<T extends Record<string, any> = Record<string, any>>(metaData: T): ClassDecorator {
	return function (target: any) {
		Reflect.defineMetadata(METADATA_DECORATOR_KEY.valueOf(), metaData, target);
	};
}

function getMetaData<T extends Record<string, any>>(target: any, mapFn: (item: T) => T = item => item as T): T {
	const metaData = Reflect.getMetadata(METADATA_DECORATOR_KEY.valueOf(), target);
	return mapFn(metaData);
}

/* -------------------------------------------------------------------------------------------------------------- */
globalThis.METADATA_DECORATOR_KEY = Symbol('metadata');
globalThis.PropMetaData = PropMetaData;
globalThis.ClassMetaData = ClassMetaData;
globalThis.getMetaData = getMetaData;
/* -------------------------------------------------------------------------------------------------------------- */
const globalGroupDecorators = new Map<string, any[]>();

function GroupDecorator(groupID: string, isGlobal = false): ClassDecorator {
	return function (target: any) {
		Reflect.defineMetadata(GROUP_DECORATOR_KEY.valueOf(), groupID, target);
		if (isGlobal) {
			if (!globalGroupDecorators.has(groupID)) globalGroupDecorators.set(groupID, []);
			globalGroupDecorators.get(groupID).push(target);
		}
	};
}

function GroupItemDecorator(groupID: string, isGlobal = false): PropertyDecorator {
	return function (target: any, propertyKey: string) {
		Reflect.defineMetadata(GROUP_DECORATOR_KEY.valueOf(), groupID, target, propertyKey);
		if (isGlobal) {
			if (!globalGroupDecorators.has(groupID)) globalGroupDecorators.set(groupID, []);
			globalGroupDecorators.get(groupID).push(target);
		}
	};
}

function getGroupDecoratorData<T>(groupID: string, mapFn: (item: any) => T = item => item as T): T[] {
	const groupData = globalGroupDecorators.get(groupID) || [];
	return groupData.map(mapFn);
}

globalThis.GROUP_DECORATOR_KEY = Symbol('group-decorator');
globalThis.GroupDecorator = GroupDecorator;
globalThis.GroupItemDecorator = GroupItemDecorator;
globalThis.getGroupDecoratorData = getGroupDecoratorData;

export {};
